import React from "react";
import { IconButton } from "@evergis/ui";
import { GradientRight, AxisControllerContainer } from "../styled";

export default ({ onClick }) => (
  <AxisControllerContainer>
    <GradientRight />
    <IconButton style={{ width: "3rem" }} kind="settings" onClick={onClick} />
  </AxisControllerContainer>
);
